export const homeRoutesName = {
    home: "home",
};
